module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/other-kp/component/other-kp-main/other-kp-main-modal-region/other-kp-main-modal-region.component.sass
// module id = ./src/app/modules/other-kp/component/other-kp-main/other-kp-main-modal-region/other-kp-main-modal-region.component.sass
// module chunks = main